export enum Browser {
  EDGE = 'edge',
  FIREFOX = 'firefox',
  SAFARI = 'safari',
  CHROME = 'chrome',
  OPERA = 'opera',
  IE = 'ie',
  UNKNOWN = 'unknown'
}
